export const meta = {
    keyExpr: 'kod_ttrans',
    columns: [
        {
            name: 'kod_ttrans',
            caption: 'kod_ttrans',
            dataField: 'kod_ttrans',
            allowEditing: true,
            width: 250,
            index: 1,
            visible: false,
        },

        {
            name: 'name',
            caption: 'Марка',
            dataField: 'name',
            allowEditing: true,
            width: 300,
            index: 2,
            fixed: true,
            visible: true,
        },
        {
            name: 'power',
            caption: 'Номин. мощность Sн(кВА)',
            dataField: 'power',
            allowEditing: true,
            width: 120,
            index: 3,
            visible: true,
        },
        {
            name: 'n_obm',
            caption: 'Кол-во обмоток',
            dataField: 'n_obm',
            allowEditing: true,
            width: 120,
            index: 4,
            visible: true,
        },
        {
            name: 'hasmlkwnd',
            caption: 'Расщепленная обмотка НН',
            dataField: 'hasmlkwnd',
            allowEditing: true,
            dataType: 'boolean',
            width: 120,
            index: 5,
            visible: true,
        },
        {
            name: 'cnt_phase',
            caption: 'Кол. фаз',
            dataField: 'cnt_phase',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'cnt_phase_text',
            },
            component: {
                name: 'cnt-phase-lookup',
                id: 'cnt_phase',
                text: 'phase_name',
            },
            width: 120,
            index: 6,
            visible: true,
        },

        {
            name: 'bh',
            caption: 'U вн(кВ)',
            dataField: 'kod_v_bh',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'nv_bh',
            },
            component: {
                name: 'nv-lookup-view',
                id: 'kod_v',
                text: 'nv',
            },
            width: 120,
            index: 7,
            visible: true,
        },
        {
            name: 'ch',
            caption: 'U сн(кВ)',
            dataField: 'kod_v_ch',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'nv_ch',
            },
            component: {
                name: 'nv-lookup-view',
                id: 'kod_v',
                text: 'nv',
            },
            width: 120,
            index: 8,
            visible: true,
        },
        {
            name: 'hh',
            caption: 'U нн(кВ)',
            dataField: 'kod_v_hh',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'nv_hh',
            },
            component: {
                name: 'nv-lookup-view',
                id: 'kod_v',
                text: 'nv',
            },
            width: 120,
            index: 9,
            visible: true,
        },
        {
            name: 'r',
            caption: 'Сопротивление трансформатора (Ом)',
            dataField: 'r',
            allowEditing: true,
            width: 120,
            index: 10,
            visible: true,
        },
        {
            name: 'dp_xx',
            caption: 'Потери мощности ХХ (кВт)',
            dataField: 'dp_xx',
            allowEditing: true,
            width: 120,
            index: 11,
            visible: true,
        },
        {
            name: 'i_xx',
            caption: 'Ток холостого хода Ixx(%)',
            dataField: 'i_xx',
            allowEditing: true,
            width: 120,
            index: 12,
            visible: true,
        },
        {
            name: 'dp_bh',
            caption: 'Потери мощности КЗ (вн-нн) (кВт)',
            dataField: 'dp_bh',
            allowEditing: true,
            width: 120,
            index: 13,
            visible: true,
        },
        {
            name: 'dp_ch',
            caption: 'Потери мощности КЗ (вн-сн) (кВт)',
            dataField: 'dp_ch',
            allowEditing: true,
            width: 120,
            index: 14,
            visible: true,
        },
        {
            name: 'dp_hh',
            caption: 'Потери мощности КЗ (сн-нн) (кВт)',
            dataField: 'dp_hh',
            allowEditing: true,
            width: 120,
            index: 15,
            visible: true,
        },
        {
            name: 'u_bh_ch',
            caption: 'U кз(вн-сн)(%)',
            dataField: 'u_bh_ch',
            allowEditing: true,
            width: 120,
            index: 16,
            visible: true,
        },
        {
            name: 'u_bh_hh',
            caption: 'U кз(вн-нн)(%)',
            dataField: 'u_bh_hh',
            allowEditing: true,
            width: 120,
            index: 17,
            visible: true,
        },
        {
            name: 'u_ch_hh',
            caption: 'U кз(сн-нн)(%)',
            dataField: 'u_ch_hh',
            allowEditing: true,
            width: 120,
            index: 18,
            visible: true,
        },

        {
            name: 'p_kz_bh',
            caption: 'Мощность обмотки(вн) Sн-вн (кВА)',
            dataField: 'p_kz_bh',
            allowEditing: true,
            width: 120,
            index: 19,
            visible: true,
        },
        {
            name: 'p_kz_ch',
            caption: 'Мощность обмотки(вн) Sн-cн (кВА)',
            dataField: 'p_kz_ch',
            allowEditing: true,
            width: 120,
            index: 20,
            visible: true,
        },
        {
            name: 'p_kz_hh',
            caption: 'Мощность обмотки(вн) Sн-нн (кВА)',
            dataField: 'p_kz_hh',
            allowEditing: true,
            width: 120,
            index: 21,
            visible: true,
        },

        {
            name: 'ih_bh',
            caption: 'Номин. ток Iн (вн)(А)',
            dataField: 'ih_bh',
            allowEditing: true,
            width: 120,
            index: 22,
            visible: true,
        },
        {
            name: 'ih_ch',
            caption: 'Номин. ток Iн (сн)(А)',
            dataField: 'ih_ch',
            allowEditing: true,
            width: 120,
            index: 23,
            visible: true,
        },
        {
            name: 'ih_hh',
            caption: 'Номин. ток Iн (нн)(А)',
            dataField: 'ih_hh',
            allowEditing: true,
            width: 120,
            index: 24,
            visible: true,
        },
        {
            name: 'p_ratio_bh',
            caption: 'Соотношение мощностей обмоток (вн, %)',
            dataField: 'p_ratio_bh',
            allowEditing: true,
            width: 120,
            index: 25,
            visible: true,
        },
        {
            name: 'p_ratio_ch',
            caption: 'Соотношение мощностей обмоток (сн, %)',
            dataField: 'p_ratio_ch',
            allowEditing: true,
            width: 120,
            index: 26,
            visible: true,
        },
        {
            name: 'p_ratio_hh',
            caption: 'Соотношение мощностей обмоток (нн, %)',
            dataField: 'p_ratio_hh',
            allowEditing: true,
            width: 120,
            index: 27,
            visible: true,
        },

        {
            name: 'imported',
            caption: 'Импортирована',
            dataField: 'imported',
            allowEditing: false,
            dataType: 'boolean',
            width: 120,
            index: 28,
            visible: true,
        },
    ],
    api: {
        select: 'core./core/hs-typetrans-select/get',
        save: 'core./core/hs-typetrans-save/set',
    },
    viewId: 'typetrans-view',
    title: 'Марки силовых трансформаторов',
    icon: 'child-svg',
};
